<template>
  <div class="course-wrapper clearfix">
    <div>
      <div class="tab-wrapper">
        <template v-for="(item,idx) in arrTabs">
          <span
            :key="idx"
            :class="[item.id==tabId?'tab-on':'tab-un']"
            v-if="idx<6"
            @click="tabClick(item.id)"
          >{{item.value}}</span>
        </template>
      </div>
      <div class="clearfix course-content">
        <template v-for="item in arrArticle">
          <div
            class="cell"
            :key="item.id"
            @click="showQRcode"
          >
            <img
              :src="item.picUrl"
              alt=""
            >
            <div>
              <span>{{item.title}}</span>
            </div>
          </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import Axios from 'axios';
const base = 'http://qaq.chengtianapp.com'
export default {
  name: 'course',
  props: {
    msg: String
  },
  data () {
    return {
      arrTabs: [],
      arrArticle: [],
      tabId: 0
    };
  },
  created () {
    var _this = this
    var url = base + '/api/case/classify';
    Axios.get(url).then((response) => {
      this.arrTabs = response.data.data;
      this.tabId = response.data.data[0].id
      _this.getCouseList()
    }).catch((error) => {
      console.log(error);
    })
  },
  methods: {
    tabClick (index) {
      this.tabId = index
      this.getCouseList()
    },
    getCouseList () {
      const { tabId } = this
      var _this = this
      var url = base + '/api/case?typeId=' + tabId + '&pageSize=14';
      Axios.get(url).then((response) => {
        _this.$nextTick(() => {
          //这里才可以
          _this.arrArticle = []
          _this.arrArticle = response.data.data
          console.log(response.data.data)
        })

      }).catch((error) => {
        console.log(error);
      })
    },
    showQRcode () {
      this.$emit('showbigcode')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.course-wrapper {
  width: 100%;
}

.course-wrapper .tab-wrapper {
  font-size: 18px;
  margin-right: 100px;
  height: 64px;
  margin-left: 30px;
}

.course-wrapper .tab-wrapper span {
  margin-right: 40px;
  line-height: 64px;
  font-weight: bold;
  cursor: pointer;
  padding: 10px 20px;
}

.course-wrapper .tab-on {
  background-color: #dc371b;
  color: #fff;
}

.course-wrapper .tab-un {
  background-color: #fff;
  color: #dc371b;
}

.cell {
  float: left;
  width: 215px;
  margin-top: 10px;
  margin-left: 20px;
  height: 210px;
  /* display: inline-block; */
}

.cell img {
  width: 215px;
  height: 160px;
}

.course-content {
  /* width: 1176px; */
  width: 100%;
  box-sizing: border-box;
  padding-left: 10px;
  margin: 0 auto;
}
</style>
